<div class="status-card"
[ngStyle]="{'background-color': currentStatus.bgColor}"
>
  <div class="status-left-content" >
    <div class="app-no" >
      <wm-common-text [data]="{text:`Application #${applicationNumber} `}" ></wm-common-text>
    </div>
    <div class="app-details">
      @if (statusCode === 1 || statusCode === 0) {
        <wm-common-text [data]="{text:'InProgress'}" ></wm-common-text>
      }@else if (statusCode === 2) {
        <wm-common-text [data]="{text:`Completed on ${startedDate | date: 'M/d/yyyy'} by ${submitter}`}" ></wm-common-text>
      }@else {
        <wm-common-text [data]="{text:`Submitted by ${submitter} on ${startedDate | date: 'M/d/yyyy'}`}" ></wm-common-text>
      }
    </div>
  </div>
  <div class="status-right-content">
    @if(linkedApplications.length > 0){
   <ng-container *ngTemplateOutlet="linkedApplicationsTemplate"></ng-container>
    }
    @if(hasFees && fees){
      <app-common-estimate-total-fee
                [currentActivity]="currentActivity"
                [applicationId]="applicationId"
                class="sidebar-child"
                [fees]="fees"
                  >

          </app-common-estimate-total-fee>
    }

    <mat-icon class="status-icon" [matTooltip]="currentStatus.label"
    [ngStyle]="{'color': currentStatus.textColor}"
    >{{ currentStatus.icon }}</mat-icon>
  </div>
</div>


<ng-template #linkedApplicationsTemplate>
<div class="estimated-total-card"  [class.expanded-fee]="showLinkedApplications"
>
  <div class="estimated-header" [class.expanded-header]="showLinkedApplications"
  >
    <div class="estimated-info">
      <wm-common-text
        [data]="{ text: 'Related Permits : ' }"
        class="estimated-label"
      ></wm-common-text>

      <wm-common-text
        [data]="{ text: linkedApplications.length}"
        class="estimated-amount"
      ></wm-common-text>
    </div>

    <wm-common-text
      [data]="{ text: showLinkedApplications ? 'Close' : 'View' }"
      class="estimated-link"
      (click)="toggleDetails()"
    ></wm-common-text>
  </div>
@if(showLinkedApplications === true){
  <div class="estimated-details">
    <ng-container >
      <div class="fee-row" *ngFor="let la of linkedApplications" >
        <a 
        [routerLink]="[]"
      [queryParams]="{ id: la.workflowApplicationId, s:'external' }"
      queryParamsHandling="replace"
      target="_blank"
        style="color: #2196f3;text-decoration: underline; cursor: pointer;" >
              {{ la.applicationNumber }} 
            </a>
      </div>
    </ng-container>
  </div>
}
</div>
</ng-template>